/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Sell_Desc4Inputs */

const en_svc_full_stack_web_apps_sell_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe subscriptions, usage metering, and gate logic so the product can pay for itself from day one.`)
};

const ar_svc_full_stack_web_apps_sell_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اشتراكات Stripe وقياس استخدام ومنطق بوابات حتى يدفع المنتج تكلفته من اليوم الأول.`)
};

const bn_svc_full_stack_web_apps_sell_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe সাবস্ক্রিপশন, ইউসেজ মিটারিং ও গেট লজিক, পণ্য প্রথম দিন থেকে নিজের খরচ তুলতে পারে।`)
};

const de_svc_full_stack_web_apps_sell_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe-Abonnements, Nutzungsmessung und Gate-Logik, damit sich das Produkt vom ersten Tag an amortisiert.`)
};

const es_svc_full_stack_web_apps_sell_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripciones de Stripe, medición de uso y lógica de puerta para que el producto pueda amortizarse por sí solo desde el primer día.`)
};

const fr_svc_full_stack_web_apps_sell_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnements Stripe, mesure de l'utilisation et logique de porte pour que le produit puisse s'autofinancer dès le premier jour.`)
};

const pt_svc_full_stack_web_apps_sell_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribua assinaturas, medição de uso e lógica de portão para que o produto possa se pagar desde o primeiro dia.`)
};

const zh_svc_full_stack_web_apps_sell_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe 订阅、用量计量和付费门槛，让产品第一天就自己养活自己。`)
};

const tr_svc_full_stack_web_apps_sell_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe abonelikleri, kullanım ölçümü ve gate mantığıyla ürün ilk günden kendini ödesin.`)
};

const ru_svc_full_stack_web_apps_sell_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписки Stripe, metering использования и гейт-логика, чтобы продукт окупался с первого дня.`)
};

const pl_svc_full_stack_web_apps_sell_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Sell_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subskrypcje Stripe, metering użycia i logika gate'ów, produkt spłaca się od pierwszego dnia.`)
};

/**
* | output |
* | --- |
* | "Stripe subscriptions, usage metering, and gate logic so the product can pay for itself from day one." |
*
* @param {Svc_Full_Stack_Web_Apps_Sell_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_sell_desc4 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Sell_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Sell_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_sell_desc4(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_sell_desc4(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_sell_desc4(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_sell_desc4(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_sell_desc4(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_sell_desc4(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_sell_desc4(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_sell_desc4(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_sell_desc4(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_sell_desc4(inputs)
	return en_svc_full_stack_web_apps_sell_desc4(inputs)
});
export { svc_full_stack_web_apps_sell_desc4 as "svc_full-stack-web-apps_SELL_desc" }